import * as _ from "lodash";
import * as React from "react";
import * as moment from "moment";
import { MedicinePrescriptionItemRequest } from "@curefit/gmf-common";
import {IDosage} from "@curefit/care-common";
import { AppConstants, DosageSlots, ORION_IMG_URL } from "../../../utils/AppConstants";
import AppUtils from "../../../utils/AppUtils";
import {MedicineInstructionCodes} from "../../../models/Consultation";

interface MedicineDosagePDFViewProps {
    dosage: IDosage[];
}
export class MedicineDosagePDFView extends React.Component<MedicineDosagePDFViewProps> {

    render() {
        let dosageItem = !_.isEmpty(this.props.dosage) ? this.props.dosage : [];
        let breakfastSlot = dosageItem.filter(item => item.slot === DosageSlots.BREAKFAST);
        let lunchSlot = dosageItem.filter(item => item.slot === DosageSlots.LUNCH);
        let dinnerSlot = dosageItem.filter(item => item.slot === DosageSlots.DINNER);
        return <div className={"dosage-row"}>
            <div className={"breakfast-slot"}>
                <div className={`slot-icon ${!_.isEmpty(breakfastSlot) && breakfastSlot[0].quantity > 0 ? "active" : ""}`}><span/></div>
                <div className={`slot-label ${!_.isEmpty(breakfastSlot) && !_.isEmpty(breakfastSlot[0].quantity > 0) ? "active" : ""}`}>Breakfast</div>
                <div className={"slot-quantity"}>{!_.isEmpty(breakfastSlot) && breakfastSlot[0].quantity > 0 ? breakfastSlot[0].quantity : null}</div>
            </div>
            <div className={"lunch-slot"}>
                <div className={`slot-icon ${!_.isEmpty(lunchSlot) && lunchSlot[0].quantity > 0 ? "active" : ""}`}><span/></div>
                <div className={`slot-label ${!_.isEmpty(lunchSlot) && lunchSlot[0].quantity > 0 ? "active" : ""}`}>Lunch</div>
                <div className={"slot-quantity"}>{!_.isEmpty(lunchSlot) && lunchSlot[0].quantity > 0 ? lunchSlot[0].quantity : null}</div>
            </div>
            <div className={"dinner-slot"}>
                <div className={`slot-icon ${!_.isEmpty(dinnerSlot) && dinnerSlot[0].quantity > 0 ? "active" : ""}`}><span/></div>
                <div className={`slot-label ${!_.isEmpty(dinnerSlot) && dinnerSlot[0].quantity > 0 ? "active" : ""}`}>Dinner</div>
                <div className={"slot-quantity"}>{!_.isEmpty(dinnerSlot) && dinnerSlot[0].quantity > 0 ? dinnerSlot[0].quantity : null}</div>
            </div>
        </div>
    }
}

export interface MedicinePlanPDFProps {
    id: string;
    planItem: any;
    includeBorder: boolean;
    showDate?: boolean;
}
const MedicinePlanPDFTemplate: React.StatelessComponent<MedicinePlanPDFProps> = (props: MedicinePlanPDFProps) => {
    let id = props.id;
    let planItem = props.planItem;
    let itemsToIterate = planItem[id];
    let includeBorder = props.includeBorder;
    let showDate = props.showDate;
    return (
        <div id={id} className={`prescription-grid-row external-row ${includeBorder ? "include-border" : ""}`}>
            <div className="prescription-card-content prescription-card-content-full">
                <div className={`${id}-header brandon-bold`}><img src={ORION_IMG_URL + "icons/medicine-header-icon.svg"} className={"header-icon"} />MEDICINES</div>
                <div id={`${id}-subsection`} className="prescription-description">
                    {
                        _.map(itemsToIterate, (medicine: MedicinePrescriptionItemRequest, index) => {
                            const medicineDosages = !_.isEmpty(medicine.slotList) ? medicine.slotList : [];
                            // const medicineDosages = !_.isEmpty(medicine.medicineDuration) && !_.isEmpty(medicine.slotList) ? medicine.slotList : [];
                            return <div key={`${medicine}-${index}`} className={"medicine-item"}>
                                <div className={"medicine-name medicine-column"}>
                                    <div className={"brandon-bold"}>{medicine.brand.displayValue}</div>
                                    <div className={"medicine-generic-name"}>{medicine.genericName.displayValue}</div>
                                    {
                                        showDate &&
                                        <div className={"medicine-date"}>Prescribed on: {moment(medicine.startEpoch).format("DD/MM/YYYY")}</div>
                                    }
                                </div>
                                <div className={"dosage-duration-comments-container"}>
                                    <div className={"medicine-dosage medicine-column"}>
                                        <MedicineDosagePDFView dosage={medicineDosages}/>
                                    </div>
                                    <div className={"medicine-duration medicine-column"}>
                                        {
                                            !_.isEmpty(medicine.medicineDuration) && !_.isNull(medicine.medicineFrequency) && !_.isEmpty(medicine.medicineFrequency) &&
                                            <div>
                                                {AppUtils.convertMedicineDosageToText(medicine.medicineFrequency.count)} every {medicine.medicineFrequency.count} {AppConstants.FrequencyUnit[medicine.medicineFrequency.unit]}
                                            </div>
                                        }
                                        {
                                            !_.isEmpty(medicine.medicineDuration) && !_.isEmpty(medicine.medicineDuration.unit) && !_.isNull(medicine.medicineDuration.count) &&
                                            <div>
                                                for {medicine.medicineDuration.count} {AppConstants.FrequencyUnit[medicine.medicineDuration.unit]}
                                            </div>
                                        }
                                    </div>
                                    {
                                        !_.isEmpty(medicine.medicineInstructions) &&
                                        <div className={"medicine-instructions brandon-bold"}>
                                            {
                                                medicine.medicineInstructions.map(item => {
                                                    return (
                                                        <span className={"instruction-item"}>{MedicineInstructionCodes[item.internalValue]}</span>
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                    {
                                        !_.isEmpty(medicine.comments) &&
                                        <div className={"medicine-comment"}>
                                            {medicine.comments}
                                        </div>
                                    }
                                </div>
                            </div>})
                    }
                </div>
            </div>
        </div>
    )
}

export default MedicinePlanPDFTemplate;